import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Dragović from '../../img/Agenda/Dragović.png'
import Taraba from '../../img/Agenda/Taraba.png'
import fave from '../../img/Agenda/fave.png'
import SS from '../../img/Agenda/SS.png'
import dropbox from '../../img/Agenda/dropbox.png'
import Meesala from '../../img/Agenda/Meesala.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '09:10',
                    photo: Meesala,
                    name: 'Vasu Meesala',
                    position: 'Senior QA Engineer',
                    ln: 'https://www.linkedin.com/in/vasu-meesala/',
                    logo: dropbox,
                    title: 'Lean QA team Embedded into Engineering team',
                    abstract: `Lean QA team Embedded into Engineering team: Quality of a software products is everyone’s responsibility. As Quality Engineers drive the quality process and quality ensure product features, engaging the engineers and taking risk first approach helps to maintain lean QA team in the organization. This talk is going to go over the processes on how to setup lean QA team in an organization, how to use risk first approach and guard rails to ship high quality products rapidly.`,
                },
                {
                    time: '09:40',
                    photo: Dragović,
                    name: 'Milomir Dragović',
                    position: 'CEO | Software Engineer',
                    ln: 'https://www.linkedin.com/in/milomirdragovic',
                    logo: Taraba,
                    title: 'How to start testing for web accessibility?',
                    abstract: `As a QA you often get frustrated when you have to report some obvious mistakes, the text is way too small, and the website is clearly not mobile-friendly. Or not mention when the navigation is so complicated that you need time to figure out where to start testing. Well, there is one group of users that experience this every day when using the websites. That’s where web accessibility comes into the game.

                    Come hear Milomir explain how he started learning and testing for accessibility on the websites. You can use the skills you already have to make your websites more accessible. This will improve website SEO and performance score. And also increasing its user base up to 20% by making it more accessible to users with disabilities.`,
                },
                {
                    time: '10:10',
                    photo: SS,
                    name: 'Nithin SS',
                    position: 'Engineering Manager, QA',
                    ln: 'https://www.linkedin.com/in/nithin-ss',
                    tw: 'https://twitter.com/Nithin_Synapse',
                    logo: fave,
                    title: 'The Curious Case of Mobile App Performance Testing',
                    abstract: `In mobile app spaces, with all these evolving technologies and competitors, performance plays an important role in terms of delivering a seamless end-user experience. Improving performance has become the top priority for all global mobile app companies, as it directly impacts user experience, retention rates, conversions, and ultimately revenue. 
                    Even if we deliver a brilliant feature, if there are performance issues people will eventually stop using those apps. As high-performing apps are user favorites, we testers should also adopt performance-centric strategies while testing mobile apps.`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">October 18 09:00 - 19:30</p>
                    <p className="agenda_day">Entry level Track</p>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/qa22vol2' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};